import gql from "graphql-tag";
import emailsTemplate from "queries/fragments/emailsTemplate";
const GET_EMAILS_TEMPLATE = gql `
  ${emailsTemplate}

  query getEmailsTemplate($id: ID!) {
    getEmailsTemplate(id: $id) {
      ...EmailsTemplate
    }
  }
`;
export default GET_EMAILS_TEMPLATE;
